import AssetService from '../../shared/services/AssetService';
import {
  AnalysisCaptureAsset,
  ScreenCaptureItem
} from '../models/LessonComponentContent';

export interface ICaptures {
  captures: ScreenCaptureItem[] | AnalysisCaptureAsset[];
  owner?: number;
  setLoading: (status: boolean) => void;
  setItems: (items: ScreenCaptureItem[]) => void;
}

class ScreenCaptureUtility {
  /**
   * fetchItems from azure
   */
  public fetchItems(props: ICaptures) {
    props.setLoading(true);
    Promise.all(
      props.captures?.map(async (capture) => {
        const url = props.owner
          ? await AssetService.getLearnerAssetUrl(props.owner, capture.id)
          : AssetService.getAssetUrl(capture.id);
        return {
          id: capture.id,
          image: url,
          state: capture.state
        };
      })
    )
      .then(props.setItems)
      .finally(() => props.setLoading(false));
  }
}

export default new ScreenCaptureUtility();
